// Displays report based on input from updatedReport page
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ActivitiesRptUpdated from './ActivitiesRptUpdated';
import ActivityByHrRpt from './ActivityByHrRpt';
import InTicketsReport from './InTicketsReport';
import ClosedTicketsReport from './OutTicketsReport';
import ManualCheckOutsRptUpdated from './ManualCheckOutsRptUpdated';
import { convertToDatabaseDateTime } from '../helpers/timeDifference';
import {
  fetchReportData,
  fetchActivityByHours,
  fetchStayDurationReport,
  fetchOpenTickets,
  fetchClosedTickets,
  listWaitTimeStats,
  fetchInTicketsData,
  fetchOmittedTickets,
  fetchManuallyClosedTicket,
  fetchTotalInTicketsByDate,
  fetchClosedTicketsData,
  fetchTotalClosedTicketsByDate,
} from '../helpers/reportsDataAPI';
import { serverURL } from '../helpers/dataServerURL';
import styles from '../css/reportDisplay.module.css';
import StayDurationRptUpdated from './StayDurationRptUpdated';
import WaitTimeRptUpdated from './WaitTimeRptUpdated';
import OmittedTicketsRptUpdated from './OmittedTicketsRptUpdated';

function ReportDisplay() {
  const [reportData, setReportData] = useState([]);
  const [inTicketsTotal, setInTicketsTotal] = useState([]);
  const [outTicketsTotal, setOutTicketsTotal] = useState([]);
  const location = useLocation();
  const loginURL = serverURL.server.url;

  useEffect(() => {
    if (location?.state?.rptNumber === 1) {
      async function activity() {
        setReportData(await fetchReportData(loginURL, location?.state?.startDate, location?.state?.endDate));
      }
      activity();
    } else if (location?.state?.rptNumber === 2) {
      async function byHour() {
        setReportData(await fetchActivityByHours(loginURL, location?.state?.startDate, location?.state?.endDate));
      }
      byHour();
    } else if (location?.state?.rptNumber === 3) {
      async function duration() {
        setReportData(
          await fetchStayDurationReport(loginURL, location?.state?.startDate, location?.state?.endDate),
        );
      }
      duration();
    } else if (location?.state?.rptNumber === 4) {
      async function waitTime() {
        setReportData(await listWaitTimeStats(loginURL, location?.state?.startDate, location?.state?.endDate));
      }
      waitTime();
    } else if (location?.state?.rptNumber === 5) {
      async function openTickets() {
        setReportData(await fetchOpenTickets(loginURL, location?.state?.startDate, location?.state?.endDate));
      }
      openTickets();
    } else if (location?.state?.rptNumber === 6) {
      async function closedTickets() {
        setReportData(await fetchClosedTickets(loginURL, location?.state?.startDate, location?.state?.endDate));
      }
      closedTickets();
    } else if (location?.state?.rptNumber === 7) {
      async function inTickets() {
        setReportData(await fetchInTicketsData(loginURL, location?.state?.startDate, location?.state?.endDate));
        setInTicketsTotal(
          await fetchTotalInTicketsByDate(loginURL, location?.state?.startDate, location?.state?.endDate),
        );
      }
      inTickets();
    } else if (location?.state?.rptNumber === 8) {
      async function outTickets() {
        setReportData(
          await fetchClosedTicketsData(loginURL, location?.state?.startDate, location?.state?.endDate),
        );
        setOutTicketsTotal(
          await fetchTotalClosedTicketsByDate(loginURL, location?.state?.startDate, location?.state?.endDate),
        );
        console.log(reportData, outTicketsTotal, 'Out tickets report data');
      }
      outTickets();
    } else if (location?.state?.rptNumber === 9) {
      async function manualTickets() {
        setReportData(
          await fetchManuallyClosedTicket(loginURL, location?.state?.startDate, location?.state?.endDate),
        );
      }
      manualTickets();
    } else if (location?.state?.rptNumber === 10) {
      async function omittedTickets() {
        setReportData(await fetchOmittedTickets(loginURL, location?.state?.startDate, location?.state?.endDate));
      }
      omittedTickets();
    }
  }, []);

  return (
    <div className={styles.topContainer}>
      <div className={styles.reportHeaderDiv}>
        <h2 className={styles.reportHeader}>
          {location?.state?.rptName} from {location?.state?.startDate} to {location?.state?.endDate}
        </h2>
      </div>

      {location?.state?.rptNumber === 1 ? (
        <ActivitiesRptUpdated
          reportData={reportData}
          fromDate={location?.state?.startDate}
          toDate={location?.state?.endDate}
        /> //Activity report
      ) : location?.state?.rptNumber === 2 ? (
        <ActivityByHrRpt
          reportData={reportData}
          fromDate={location?.state?.startDate}
          toDate={location?.state?.endDate}
        /> //Activity summary by hour
      ) : location?.state?.rptNumber === 3 ? (
        <StayDurationRptUpdated
          reportData={reportData}
          fromDate={location?.state?.startDate}
          toDate={location?.state?.endDate}
        /> //Duration stay
      ) : location?.state?.rptNumber === 4 ? (
        <WaitTimeRptUpdated
          reportData={reportData}
          fromDate={location?.state?.startDate}
          toDate={location?.state?.endDate}
        /> // Wait time report --not ready
      ) : location?.state?.rptNumber === 5 ? (
        <ActivitiesRptUpdated
          reportData={reportData}
          fromDate={location?.state?.startDate}
          toDate={location?.state?.endDate}
        /> //Open tickets report
      ) : location?.state?.rptNumber === 6 ? (
        <StayDurationRptUpdated
          reportData={reportData}
          fromDate={location?.state?.startDate}
          toDate={location?.state?.endDate}
        /> //Closed tickets report
      ) : location?.state?.rptNumber === 7 ? (
        <InTicketsReport
          data={reportData}
          totalInTickets={inTicketsTotal}
          start={convertToDatabaseDateTime(location?.state?.startDate)}
          end={convertToDatabaseDateTime(location?.state?.endDate)}
        /> //In tickets broken down by dates and hours
      ) : location?.state?.rptNumber === 8 ? (
        <ClosedTicketsReport
          data={reportData}
          totalOutTickets={outTicketsTotal}
          start={convertToDatabaseDateTime(location?.state?.startDate)}
          end={convertToDatabaseDateTime(location?.state?.endDate)}
        />
      ) : location?.state?.rptNumber === 9 ? (
        <ManualCheckOutsRptUpdated
          reportData={reportData}
          fromDate={location?.state?.startDate}
          toDate={location?.state?.endDate}
        />
      ) : location?.state?.rptNumber === 10 ? (
        <OmittedTicketsRptUpdated
          reportData={reportData}
          fromDate={location?.state?.startDate}
          toDate={location?.state?.endDate}
        />
      ) : null}
    </div>
  );
}

export default ReportDisplay;
